import { useState, useEffect } from "react";
import {
  IDashboardFilters,
  IDashboardFilterOptions,
} from "../interfaces/dashboard";
import { fetchDashboardFilterOptions } from "../requests/dashboardRequests";

const EMPTY_OPTIONS: IDashboardFilterOptions = {
  statuses: [],
  carriers: [],
  provinces: [],
  merchants: [],
  clients: [],
  countries: [],
};

// Carga las opciones de filtro (Operador/Estado/Provincia/Merchant) presentes en
// los datos del período. Depende de los filtros BASE del scope (fechas +
// marketplace + client_id): al cambiar el Cliente (usuario interno) las opciones
// se recargan para reflejar el universo de ese cliente. Las dimensiones ya
// seleccionadas no acotan las opciones (Opción A). Ante error, cae a opciones
// vacías: la barra queda usable (solo fechas) sin romper el render.
export const useDashboardFilterOptions = (
  filters: IDashboardFilters,
): { options: IDashboardFilterOptions; loading: boolean } => {
  const [options, setOptions] =
    useState<IDashboardFilterOptions>(EMPTY_OPTIONS);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let ignore = false;
    setLoading(true);

    fetchDashboardFilterOptions(filters)
      .then((data) => {
        if (!ignore) setOptions(data);
      })
      .catch(() => {
        if (!ignore) setOptions(EMPTY_OPTIONS);
      })
      .finally(() => {
        if (!ignore) setLoading(false);
      });

    return () => {
      ignore = true;
    };
  }, [filters.from, filters.to, filters.marketplaceId, filters.client_id, filters.country]);

  return { options, loading };
};
